import React from 'react';
import { IonContent, IonPage } from '@ionic/react';
import SiteNav from '../components/SiteNav';
import SiteFooter from '../components/SiteFooter';
import Reveal from '../components/Reveal';

const groups = [
  {
    name: 'AI Engineering',
    label: 'Applied AI',
    accent: true,
    skills: [
      'LLM Agent Systems', 'Claude API', 'Gemini API', 'Google ADK', 'AI Safety Guardrails',
      'Prompt Injection Defense', 'Agent Autonomy Design', 'RAG', 'Voice Interfaces & TTS', 'MCP Servers & Agent Skills'
    ]
  },
  {
    name: 'Languages',
    label: 'Core',
    skills: ['Kotlin', 'Java', 'Python', 'TypeScript', 'JavaScript', 'Scala', 'C#', 'Dart']
  },
  {
    name: 'Backend',
    label: 'Frameworks',
    skills: ['Quarkus', 'Spring Boot', 'Spring Cloud', 'GraphQL', 'Jakarta EE', 'REST APIs', 'Microservices', 'Node.js', 'FastAPI']
  },
  {
    name: 'Cloud & Infrastructure',
    label: 'Platform',
    skills: ['AWS', 'AWS IoT Core', 'Kubernetes', 'Docker', 'Terraform', 'Terragrunt', 'Google Cloud Run', 'MQTT', 'LoRaWAN', 'Mbus Gateway 6']
  },
  {
    name: 'Data',
    label: 'Storage & Streams',
    skills: ['MySQL', 'MongoDB', 'DynamoDB', 'Redis', 'Elasticsearch', 'Apache Kafka', 'Amazon Kinesis']
  },
  {
    name: 'DevOps & Quality',
    label: 'Delivery',
    skills: ['Jenkins', 'GitLab CI', 'Git', 'Maven', 'Gradle', 'JUnit', 'Mockito', 'Playwright', 'Datadog', 'CloudWatch', 'OWASP', 'JWT']
  },
  {
    name: 'Frontend & Mobile',
    label: 'Client',
    skills: ['React', 'Angular', 'Ionic', 'Capacitor', 'Flutter', 'Unity', 'Android']
  }
];

const Skills: React.FC = () => (
  <IonPage>
    <IonContent>
      <SiteNav current="/skills" />
      <main className="page">
        <Reveal>
          <p className="eyebrow"><em>grep</em> -r skills ~/stack</p>
          <h1 className="display" style={{ fontSize: 'clamp(1.9rem, 5vw, 3rem)' }}>
            Technologies I work with
          </h1>
          <p className="lede">
            JVM backend at enterprise depth, cloud-native infrastructure, and a modern
            applied-AI toolchain.
          </p>
        </Reveal>

        <div style={{ marginTop: '3rem' }}>
          {groups.map((group, i) => (
            <Reveal key={group.name} delay={Math.min(i * 0.05, 0.2)}>
              <div className="skill-group">
                <h2 className="skill-group__name">
                  {group.name}
                  <small>{group.label}</small>
                </h2>
                <div className="chips">
                  {group.skills.map((skill, j) => (
                    <span className={`chip${group.accent ? ' chip--accent' : ''}`} key={j}>{skill}</span>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <SiteFooter />
      </main>
    </IonContent>
  </IonPage>
);

export default Skills;
